// Regras da casa (salas Prata), configuráveis por sala.
// A partida vai sempre até 12 e a mão de onze acontece sempre com 11: isso não é configurável.
// A mão de ferro é sempre com as cartas abertas, e esconder carta vale em toda sala.
import type { HouseRules, SignalVisibility } from './types.ts';

export const WIN_POINTS = 12;
export const ONZE_POINTS = 11;

export const DEFAULT_HOUSE_RULES: Readonly<HouseRules> = Object.freeze({
  sinais: 'aviso',
  tempoPorJogadaMs: 20000,
  vagasComBot: true,
  zoeira: true,
});

const KEYS = Object.keys(DEFAULT_HOUSE_RULES) as (keyof HouseRules)[];
// Regras que deixaram de existir: sala guardada e aparelho com a versão antiga ainda mandam, e o campo é ignorado.
const ANTIGAS = ['maoDeFerro', 'esconderCarta'];

const VISIBILIDADES: readonly SignalVisibility[] = ['desligados', 'aviso', 'todos'];

export function normalizeHouseRules(input: Partial<HouseRules> = {}): HouseRules {
  const atuais: Partial<HouseRules> = {};
  for (const [k, valor] of Object.entries(input)) {
    if (ANTIGAS.includes(k)) continue;
    if (!KEYS.includes(k as keyof HouseRules)) throw new Error('regra da casa desconhecida: ' + k);
    (atuais as Record<string, unknown>)[k] = valor;
  }
  const r: HouseRules = { ...DEFAULT_HOUSE_RULES, ...atuais };
  // Antes do lote 1, sinais era ligado ou desligado (salas guardadas e aparelhos com a versão antiga).
  if (typeof r.sinais === 'boolean') r.sinais = r.sinais ? 'aviso' : 'desligados';
  if (!VISIBILIDADES.includes(r.sinais)) throw new Error('sinais deve ser desligados, aviso ou todos');
  if (!Number.isInteger(r.tempoPorJogadaMs) || r.tempoPorJogadaMs <= 0) throw new Error('tempoPorJogadaMs deve ser um inteiro positivo');
  if (typeof r.vagasComBot !== 'boolean') throw new Error('vagasComBot deve ser verdadeiro ou falso');
  if (typeof r.zoeira !== 'boolean') throw new Error('zoeira deve ser verdadeiro ou falso');
  return r;
}
